var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _vm._m(0),
      _c(
        "div",
        { staticClass: "content search-content" },
        [
          _c("search-com", {
            attrs: { type: "user" },
            on: {
              outputSearchData: _vm.receiveSearchData,
              searchBasic: function ($event) {
                return _vm.getStatistics($event)
              },
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.baseData.loading,
              expression: "baseData.loading",
            },
          ],
          staticClass: "content",
        },
        [
          _c(
            "div",
            { staticClass: "base-data-list" },
            [
              _vm._l(_vm.baseData.list, function (item, index) {
                return [
                  _c("basic-data", {
                    key: index,
                    attrs: { basicDataItem: item, basicDataItemIndex: index },
                  }),
                ]
              }),
            ],
            2
          ),
        ]
      ),
      _c("div", { staticClass: "content table-content" }, [
        _c(
          "div",
          { staticClass: "table-content-item-side" },
          [
            _c("h3", { staticClass: "card-title" }, [
              _c("label", [
                _vm._v(" " + _vm._s(_vm.orderAmountPlatform.title) + " "),
              ]),
              _c(
                "div",
                { staticClass: "staff-button-list" },
                [
                  _c("el-button", {
                    staticClass: "download-table",
                    attrs: { size: "small", icon: "el-icon-download" },
                    on: {
                      click: function ($event) {
                        return _vm.onDownload(_vm.orderAmountPlatform.type)
                      },
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("search-com-company", {
              class: [
                { "user-form": _vm.currenRoutetName === "user" },
                "search-company",
              ],
              attrs: {
                type: _vm.orderAmountPlatform.type,
                dateArr: _vm.orderAmountPlatform.dateArr,
              },
              on: { outputSearchData: _vm.receiveSearchData },
            }),
            _c("echarts-pie", {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.orderAmountPlatform.loading,
                  expression: "orderAmountPlatform.loading",
                },
              ],
              attrs: {
                config: _vm.orderAmountPlatform.config,
                dataList: _vm.orderAmountPlatform.dataList,
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "table-content-item-side" },
          [
            _c("h3", { staticClass: "card-title" }, [
              _c("label", [_vm._v(_vm._s(_vm.layerProportion.title))]),
              _c(
                "div",
                { staticClass: "staff-button-list" },
                [
                  _c("el-button", {
                    staticClass: "download-table",
                    attrs: { size: "small", icon: "el-icon-download" },
                    on: {
                      click: function ($event) {
                        return _vm.onDownload(_vm.layerProportion.type)
                      },
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("search-com-company", {
              class: [
                { "user-form": _vm.currenRoutetName === "user" },
                "search-company",
              ],
              attrs: {
                type: _vm.layerProportion.type,
                dateArr: _vm.layerProportion.dateArr,
              },
              on: { outputSearchData: _vm.receiveSearchData },
            }),
            _c("echarts-pie", {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.layerProportion.loading,
                  expression: "layerProportion.loading",
                },
              ],
              attrs: {
                config: _vm.layerProportion.config,
                dataList: _vm.layerProportion.dataList,
              },
            }),
          ],
          1
        ),
      ]),
      _c("div", { attrs: { sclass: "" } }),
      _c("div", { staticClass: "content table-content" }, [
        _c(
          "div",
          { staticClass: "table-content-item-side" },
          [
            _c("h3", { staticClass: "card-title" }, [
              _c("label", [_vm._v(_vm._s(_vm.bronze.title))]),
            ]),
            _c("search-com-company", {
              class: [
                { "user-form": _vm.currenRoutetName === "user" },
                "search-company",
              ],
              attrs: { type: _vm.bronze.type, dateArr: _vm.bronze.dateArr },
              on: { outputSearchData: _vm.receiveSearchData },
            }),
            _c("data-board-table", {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.bronze.loading,
                  expression: "bronze.loading",
                },
              ],
              attrs: {
                dataList: _vm.bronze.list,
                config: _vm.bronze.config,
                sortObj: _vm.bronze.sortObj,
              },
            }),
            _vm.bronze.list.length > 0
              ? _c(
                  "div",
                  { staticClass: "page" },
                  [
                    _c("el-pagination", {
                      attrs: {
                        background: "",
                        "current-page": _vm.bronze.page.pageNo,
                        "page-sizes": [3, 5, 10, 20, 50],
                        "page-size": _vm.bronze.page.pageSize,
                        layout: "total, sizes, prev, pager, next, jumper",
                        total: _vm.bronze.page.totalNum,
                      },
                      on: {
                        "size-change": _vm.onChangePreferencePageBronze,
                        "current-change": _vm.onPreferenceChangeSizeBronze,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "table-content-item-side" },
          [
            _c("h3", { staticClass: "card-title" }, [
              _c("label", [_vm._v(_vm._s(_vm.silver.title))]),
            ]),
            _c("search-com-company", {
              class: [
                { "user-form": _vm.currenRoutetName === "user" },
                "search-company",
              ],
              attrs: { type: _vm.silver.type, dateArr: _vm.silver.dateArr },
              on: { outputSearchData: _vm.receiveSearchData },
            }),
            _c("data-board-table", {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.silver.loading,
                  expression: "silver.loading",
                },
              ],
              attrs: {
                dataList: _vm.silver.list,
                config: _vm.silver.config,
                sortObj: _vm.silver.sortObj,
              },
            }),
            _vm.silver.list.length > 0
              ? _c(
                  "div",
                  { staticClass: "page" },
                  [
                    _c("el-pagination", {
                      attrs: {
                        background: "",
                        "current-page": _vm.silver.page.pageNo,
                        "page-sizes": [3, 5, 10, 20, 50],
                        "page-size": _vm.silver.page.pageSize,
                        layout: "total, sizes, prev, pager, next, jumper",
                        total: _vm.silver.page.totalNum,
                      },
                      on: {
                        "size-change": _vm.onChangePreferencePageSilver,
                        "current-change": _vm.onPreferenceChangeSizeSilver,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "table-content-item-side" },
          [
            _c("h3", { staticClass: "card-title" }, [
              _c("label", [_vm._v(_vm._s(_vm.gold.title))]),
            ]),
            _c("search-com-company", {
              class: [
                { "user-form": _vm.currenRoutetName === "user" },
                "search-company",
              ],
              attrs: { type: _vm.gold.type, dateArr: _vm.gold.dateArr },
              on: { outputSearchData: _vm.receiveSearchData },
            }),
            _c("data-board-table", {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.gold.loading,
                  expression: "gold.loading",
                },
              ],
              attrs: {
                dataList: _vm.gold.list,
                config: _vm.gold.config,
                sortObj: _vm.gold.sortObj,
              },
            }),
            _vm.gold.list.length > 0
              ? _c(
                  "div",
                  { staticClass: "page" },
                  [
                    _c("el-pagination", {
                      attrs: {
                        background: "",
                        "current-page": _vm.gold.page.pageNo,
                        "page-sizes": [3, 5, 10, 20, 50],
                        "page-size": _vm.gold.page.pageSize,
                        layout: "total, sizes, prev, pager, next, jumper",
                        total: _vm.gold.page.totalNum,
                      },
                      on: {
                        "size-change": _vm.onChangePreferencePageGold,
                        "current-change": _vm.onPreferenceChangeSizeGold,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "table-content-item-side" },
          [
            _c("h3", { staticClass: "card-title" }, [
              _c("label", [_vm._v(_vm._s(_vm.recommend.title))]),
            ]),
            _c("search-com-company", {
              class: [
                { "user-form": _vm.currenRoutetName === "user" },
                "search-company",
              ],
              attrs: {
                type: _vm.recommend.type,
                dateArr: _vm.recommend.dateArr,
              },
              on: { outputSearchData: _vm.receiveSearchData },
            }),
            _c("data-board-table", {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.recommend.loading,
                  expression: "recommend.loading",
                },
              ],
              attrs: {
                dataList: _vm.recommend.list,
                config: _vm.recommend.config,
                sortObj: _vm.recommend.sortObj,
              },
            }),
          ],
          1
        ),
      ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.renewRankingList.loading,
              expression: "renewRankingList.loading",
            },
          ],
          staticClass: "content achievement",
        },
        [
          _vm._m(1),
          _c("search-com-company", {
            class: [
              { "user-form": _vm.currenRoutetName === "user" },
              "search-company",
            ],
            attrs: {
              type: _vm.renewRankingList.type,
              dateArr: _vm.renewRankingList.dateArr,
            },
            on: { outputSearchData: _vm.receiveSearchData },
          }),
          _c("data-board-table", {
            attrs: {
              dataList: _vm.renewRankingList.list,
              config: _vm.renewRankingList.config,
              sortObj: _vm.renewRankingList.sortObj,
            },
            on: { tableShowDetail: _vm.showDetail },
          }),
          _vm.renewRankingList.list.length > 0
            ? _c(
                "div",
                { staticClass: "page" },
                [
                  _c("el-pagination", {
                    attrs: {
                      background: "",
                      "current-page": _vm.renewRankingList.page.pageNo,
                      "page-sizes": [3, 5, 10, 20, 50],
                      "page-size": _vm.renewRankingList.page.pageSize,
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: _vm.renewRankingList.page.totalNum,
                    },
                    on: {
                      "size-change": _vm.onChangePreferencePageRenewRanking,
                      "current-change": _vm.onPreferenceChangeSizeRenewRanking,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialog.title,
            visible: _vm.dialog.visible,
            width: _vm.dialog.width,
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialog, "visible", $event)
            },
          },
        },
        [
          _vm.dialog.subTitle
            ? _c("template", { slot: "title" }, [
                _c("div", { staticClass: "dialog-slot-title" }, [
                  _c("label", [_vm._v(_vm._s(_vm.dialog.title))]),
                  _c("span", [
                    _vm._v(
                      "( " +
                        _vm._s(_vm.staffTableAchievementDetail.month) +
                        " )"
                    ),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm.dialog.type === "performanceStatistics"
            ? [
                _c("data-board-table", {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  attrs: {
                    dataList: _vm.staffTableAchievementDetail.page.list,
                    config: _vm.staffTableAchievementDetail.list,
                    sortObj: _vm.staffTableAchievementDetail.sortObj,
                  },
                }),
                _c(
                  "div",
                  { staticClass: "page" },
                  [
                    _c("el-pagination", {
                      attrs: {
                        background: "",
                        "current-page":
                          _vm.staffTableAchievementDetail.page.pageNo,
                        "page-sizes": [3, 5, 10, 20, 50],
                        "page-size":
                          _vm.staffTableAchievementDetail.page.pageSize,
                        layout: "total, sizes, prev, pager, next, jumper",
                        total: _vm.staffTableAchievementDetail.page.totalNum,
                      },
                      on: {
                        "size-change": _vm.staffDetailSizeChange,
                        "current-change": _vm.staffDetailCurrentChange,
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "performanceStatistics-download",
                    attrs: { size: "small", type: "primary", plain: "" },
                    on: {
                      click: function ($event) {
                        return _vm.onDownload("achievementDetail")
                      },
                    },
                  },
                  [_vm._v("下载 ")]
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content page-title" }, [
      _c("h2", [_vm._v("用户运营看板")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h3", { staticClass: "card-title" }, [
      _c("label", [_vm._v("客户拉新排行榜")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }